import { render, staticRenderFns } from "./DigitalWallet.vue?vue&type=template&id=51b86763&"
import script from "./DigitalWallet.vue?vue&type=script&lang=js&"
export * from "./DigitalWallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports